import React from 'react'
import './Sadguru_content.css'
import Common_Title_2 from '../../common/common_components/common_title_2/Common_Title_2'
import Pink_Btn from '../../common/common_btn/pink_btn/Pink_Btn'
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import { diffInDays, formatEventDate } from '../../../utils/common'
import parse from "html-react-parser"

const Sadguru_content = ({ festival }) => {
    const navigate = useNavigate();
    return (
        <>
            <section className='Sadguru_arpa_content_sec'>
                <div className='container'>
                    <div className='title_div'>
                        <h5 className='sadtitle'>{festival?.name || " "}</h5>
                        <p className='sadsubtitle'>{diffInDays(festival?.Festival?.start_date, festival?.Festival?.end_date) || "1"} days  {festival?.subname || " "}</p>
                    </div>

                    <div className='row mt-lg-2 mt-2'>
                        <div className='col-lg-9 mx-auto'>
                            <Common_Title_2 subText={'About'} />

                            <p className='sadurucont'>{parse(festival?.about || " ")}</p>

                            <div className='dailyprocessdiv'>
                                <div className='leftdiv'>
                                    <h6 className='dailyh6'>Daily Process</h6>
                                </div>
                                <div className='middiv'>

                                </div>
                                <div className='lastdiv'>
                                    <p className='date'><img className='calicon' src={process.env.PUBLIC_URL + '/assets/images/icons/calender.png'} alt="calender" /> {formatEventDate(festival?.Festival?.start_date, festival?.Festival?.end_date) || "1"}</p>
                                </div>
                            </div>


                            <div className='tablediv'>
                                <h5 className='morningh5'>{festival?.sadhana || " "}</h5>
                                <div className='table-responsive'>
                                    {parse(festival?.daily_process || " ")}
                                    {/* <table className='table table-striped '>
                                        <thead>
                                            <tr>
                                                <th>Sr.No.</th>
                                                <th>Practice</th>
                                                <th>Time</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr>
                                                <td>1</td>
                                                <td>Guru pooja</td>
                                                <td>5:30 am</td>
                                            </tr>
                                            <tr>
                                                <td>2</td>
                                                <td>Guru pooja</td>
                                                <td>5:30 am</td>
                                            </tr>
                                            <tr>
                                                <td>3</td>
                                                <td>Guru pooja</td>
                                                <td>5:30 am</td>
                                            </tr>
                                            <tr>
                                                <td>4</td>
                                                <td>Guru pooja</td>
                                                <td>5:30 am</td>
                                            </tr>
                                        </tbody>
                                    </table> */}

                                    {/* <Pink_Btn btnText={'Join'} onClick={() => (navigate('/join-event'))} className='zoom_in_out' /> */}
                                </div>
                            </div>



                            <div className='tablediv mt-5'>


                                <h5 className='morningh5'>Guidelines</h5>
                                <div className='guidelinesdiv'>
                                    {parse(festival?.guidelines || " ")}
                                    {/* <h6 className='offh6'>Offer with a pure heart, serve with devotion, & surrender every action at the Guru’s feet.</h6>

                                    <ul className='uldata'>
                                        <li>Keep your body, mind & surroundings clean</li>
                                        <li>Offer with selfless devotion, not desire</li>
                                        <li>Stay silent and inwardly focused</li>
                                        <li>Respect all and follow with discipline</li>
                                    </ul> */}
                                </div>

                                <Pink_Btn btnText={'Join'} onClick={() => (navigate('/join-event'))} className='zoom_in_out' />

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Sadguru_content